import { t } from "i18next";
import type { FunctionComponent } from "react";
import type { Workspace } from "../../../types/workspace";
import { ActivityDetails } from "../ActivityDetails/ActivityDetails/ActivityDetails";
import { HistoryLoader } from "../ActivityGrid/components/HistoryLoader/HistoryLoader";
import { StyledHistoryLoaderWrapper } from "../ActivityGrid/components/HistoryLoader/style";
import { ActivityHeader } from "../ActivityHeader/ActivityHeader";
import { StyledContainer } from "./styles";
import { Scrollbar } from "@smartsuite/react-ui/lib";

interface ActivityDetailsViewProps {
  workspace: Workspace;
  onGoBack: () => void;
  isLoading?: boolean;
}

export const ActivityDetailsView: FunctionComponent<
  ActivityDetailsViewProps
> = ({ workspace, onGoBack, isLoading }) => {
  return (
    <Scrollbar classes="space" gutterBottom={3} gutterRight={2} gutterTop={2}>
      <StyledContainer>
        <ActivityHeader
          backTooltipText={t("job-list.tooltip-text")}
          workspace={workspace}
          onGoBack={onGoBack}
          isLoading={isLoading}
        />
        {isLoading && (
          <StyledHistoryLoaderWrapper>
            <HistoryLoader />
          </StyledHistoryLoaderWrapper>
        )}
        {!isLoading && <ActivityDetails onGoBack={onGoBack} />}
      </StyledContainer>
    </Scrollbar>
  );
};
